import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'

import {
    startPlayerMatching,
} from 'state/actions/players_matching'
import { UNIT_TYPES } from 'constants'

import {
    sendClickSoundCommand,
    sendHoverSoundCommand,
} from 'react-wot-bootstrap/lib/helpers/web_to_client'
import {
    checkBattleModeAvailableAtPeriphery,
    getAvailablePeripheries,
    getPeripheriesList,
    getPeripheryById,
    isSortiesAvailable,
} from 'helpers/peripheries'

import {
    AVAILABLE_INTERIM_BEFORE_PRIME,
    GO_TO_ANOTHER_SERVER,
    START_PLAYERS_MATCHING,
    VEHICLES_NOT_READY,
} from './translations'
import { anyOfSelectedVehiclesReady } from './helpers'

import styles from './PlayersMatchingButton.scss'

export class PlayersMatchingButton extends React.Component {
    static propTypes = {
        availableInMinutesBeforePrime: PropTypes.number.isRequired,
        currentPeripheryName: PropTypes.string.isRequired,
        enabledBattleModePeripheriesNames: PropTypes.string.isRequired,
        isAllVehiclesNotReady: PropTypes.bool.isRequired,
        isAnyVehicleSelected: PropTypes.bool.isRequired,
        isDisabled: PropTypes.bool.isRequired,

        onClick: PropTypes.func.isRequired,
    }

    constructor() {
        super()
        this.onClick = this.onClick.bind(this)
    }

    onClick() {
        if (this.props.isDisabled) return null

        this.props.onClick()
    }

    render() {
        let reason = null
        if (this.props.isDisabled && this.props.isAnyVehicleSelected) {
            if (this.props.isAllVehiclesNotReady) {
                reason = VEHICLES_NOT_READY
            } else if (this.props.enabledBattleModePeripheriesNames) {
                reason = (
                    !this.props.enabledBattleModePeripheriesNames.includes(this.props.currentPeripheryName) &&
                    GO_TO_ANOTHER_SERVER(this.props.enabledBattleModePeripheriesNames)
                )
            } else {
                reason = AVAILABLE_INTERIM_BEFORE_PRIME(this.props.availableInMinutesBeforePrime)
            }
        }

        const className = classNames(styles.base, {
            [styles.base__disabled]: this.props.isDisabled,
        })
        return (
            <section>
                <p className={styles.reason}>
                    {reason}
                </p>
                <button
                    className={className}
                    onClick={this.onClick}
                    onMouseDown={sendClickSoundCommand}
                    onMouseEnter={sendHoverSoundCommand}
                >
                    {START_PLAYERS_MATCHING}
                </button>
            </section>
        )
    }
}

function canJoinPlayersMatching({ account, availableUnits, players_matching }, periphery) {
    if (!players_matching.selected_vehicle_cds) return false
    if (players_matching.selected_vehicle_cds.length === 0) return false
    if (players_matching.start_time !== null) return false

    const isSortiesUnavailable = !isSortiesAvailable(
        periphery, availableUnits.meta.sorties.players_matching_available_before * 1000
    )
    if (isSortiesUnavailable) return false

    return anyOfSelectedVehiclesReady(players_matching)
}

export const mapStateToProps = state => {
    const sorties = state.availableUnits.meta.sorties
    const availableInSecondsBeforePrime = sorties.players_matching_available_before

    let availableInMinutesBeforePrime = Math.floor(availableInSecondsBeforePrime / 60)
    const availablePeripheries = getAvailablePeripheries(
        sorties.peripheries,
        UNIT_TYPES.SORTIE,
        availableInSecondsBeforePrime * 1000
    )

    const { selected_vehicle_cds } = state.players_matching

    const periphery = getPeripheryById(
        state.availableUnits.meta.sorties.peripheries, state.account.periphery_id
    )
    const selectedSortieSetting = state.players_matching.sortie_settings
        .find(setting => setting.level === state.players_matching.vehicle_level)
    const battleMode = selectedSortieSetting ? selectedSortieSetting.battle_mode : ''
    const isBattleModeAvailableAtPeriphery = checkBattleModeAvailableAtPeriphery(
        periphery, battleMode
    )

    const enabledBattleModePeripheries = availablePeripheries.filter(
        availablePeriphery => checkBattleModeAvailableAtPeriphery(availablePeriphery, battleMode)
    )
    const enabledBattleModePeripheriesNames = getPeripheriesList(enabledBattleModePeripheries)

    return {
        availableInMinutesBeforePrime,
        enabledBattleModePeripheriesNames,
        currentPeripheryName: state.account.periphery_name,
        isAllVehiclesNotReady: !anyOfSelectedVehiclesReady(state.players_matching),
        isAnyVehicleSelected: selected_vehicle_cds !== null && selected_vehicle_cds.length > 0,
        isBattleModeAvailableAtPeriphery,
        isDisabled: !canJoinPlayersMatching(state, periphery) || !isBattleModeAvailableAtPeriphery,
    }
}

const mapDispatchToProps = {
    onClick: startPlayerMatching,
}

export default connect(mapStateToProps, mapDispatchToProps)(PlayersMatchingButton)



// WEBPACK FOOTER //
// ./containers/BattleRooms/containers/PlayersMatchingView/components/PlayersMatchingButton/PlayersMatchingButton.jsx